/**
 * StatCard — hero stat card.  One short eyebrow, one big number, one
 * helper line.  Used as an in-article callout when a single number
 * deserves the spotlight (rare; most numbers ride inline in prose).
 */

import type { LangCode } from '../architecture';

interface StatCardProps {
  eyebrow: string;
  value: string;
  helper?: string;
  lang: LangCode;
}

export function StatCard({ eyebrow, value, helper }: StatCardProps) {
  return (
    <div
      role="figure"
      className="my-6 sm:my-8 inline-flex flex-col items-start gap-1 rounded-lg border border-ink-100 bg-paper-2 px-5 py-4 sm:px-6 sm:py-5"
    >
      <span className="font-mono text-[10px] uppercase tracking-wider text-ink-500">
        {eyebrow}
      </span>
      <span className="font-display text-3xl font-medium italic tabular-nums text-terra-700 sm:text-4xl">
        {value}
      </span>
      {helper && (
        <span className="mt-1 text-xs text-ink-500 sm:text-sm">{helper}</span>
      )}
    </div>
  );
}
